import config from '../utils/EnvironmentSwitcher';

const TERMINAL_STATUSES = new Set(['completed', 'failed']);

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const enqueueAgentChatTask = async ({ token, agentId, messages, conversationId = null }) => {
  const res = await fetch(`${config.apiUrl}/api/agent-tasks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      type: 'agent_chat',
      agentId,
      messages,
      ...(conversationId ? { conversationId } : {}),
    }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Failed to enqueue task (${res.status})`);
  }

  return res.json();
};

export const enqueueAgentTask = async ({ token, body }) => {
  const res = await fetch(`${config.apiUrl}/api/agent-tasks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Failed to enqueue task (${res.status})`);
  }

  return res.json();
};

export const enqueueObservationLearningTask = async ({
  token,
  agentId = null,
  lookbackDays = 7,
  createReminders = true,
}) =>
  enqueueAgentTask({
    token,
    body: {
      type: 'learn_from_observations',
      ...(agentId ? { agentId } : {}),
      lookbackDays,
      createReminders,
    },
  });

export const getAgentTask = async ({ token, taskId }) => {
  const res = await fetch(`${config.apiUrl}/api/agent-tasks/${taskId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Failed to fetch task (${res.status})`);
  }

  return res.json();
};

export const waitForAgentTask = async ({
  token,
  taskId,
  intervalMs = 1200,
  timeoutMs = 60000,
}) => {
  const start = Date.now();

  while (Date.now() - start < timeoutMs) {
    const task = await getAgentTask({ token, taskId });
    const status = task.status;

    if (TERMINAL_STATUSES.has(status)) {
      return task;
    }

    await sleep(intervalMs);
  }

  throw new Error('Timed out waiting for task completion');
};
